module.exports = ".coverImage {\n    width: 300pt;\n    height: 300pt;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n"